import { useState } from "react"
import styles from "./index.module.scss"
import RcmpArrowDown from "../../../assets/icons/ArrowDown"
import RcmpRightArrowAccordion from "../../../assets/icons/RignArrowAccordion"

export default function RcmpAccordion(props) {
  const {
    children,
    oGetData,
    fnSetData,
    bCollapse,
    nCurrentId,
    fnSetId,
    fnUpdateDataPanel,
    subDataId,
  } = props
  const [nAccordion, fnSetNAccordion] = useState(-1)

  async function fnToggleAccordion(index, id) {
    if (index === nAccordion) {
      fnUpdateDataPanel?.(id)
      subDataId?.(-1)
      return fnSetNAccordion(-1)
    }
    subDataId?.(-1)
    fnUpdateDataPanel?.(id)
    fnSetNAccordion(index)
    await fnSetId?.(id)
  }
  async function fnSelectItem(index, data) {
    if (index === nAccordion) {
      fnSetId?.(undefined)
      return fnSetNAccordion(-1)
    }
    fnSetNAccordion(index)
    fnSetId?.(index)
    await fnSetData(data)
  }

  return (
    <div className={styles.container}>
      <div className={styles.accordionFaq}>
        {oGetData?.map((data, index) => {
          if (nCurrentId === String(data.id)) return null
          return (
            <div key={index} className={styles.accordionItem}>
              <div
                className={
                  nAccordion === index
                    ? `${styles.accordionFaqHeadActive}`
                    : `${styles.accordionFaqHead}`
                }
                onClick={
                  bCollapse
                    ? () => fnToggleAccordion(index, data.id)
                    : () => fnSelectItem(index, data)
                }
              >
                {bCollapse && (
                  <div>
                    {nAccordion === index ? (
                      <div className={styles.iconContainer}>
                        <RcmpArrowDown />
                      </div>
                    ) : (
                      <div className={styles.iconContainer}>
                        <RcmpRightArrowAccordion />
                      </div>
                    )}
                  </div>
                )}
                <p
                  className={
                    nAccordion === index
                      ? `${styles.active}`
                      : `${styles.title}`
                  }
                >
                  {data?.name}
                </p>
              </div>
              <div
                className={
                  nAccordion === index
                    ? `${(styles.active, styles.accordionContent)}`
                    : `${styles.inactive}`
                }
              >
                {children}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
